var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "314px",
    height: "111px",
    viewBox: "0 0 314 111",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Foodbit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arabic-Logos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arabic-Logo",
    transform: "translate(-162.000000, -90.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Foodbit",
    transform: "translate(162.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.67,26.479589 C211.421964,26.4155848 200.409095,33.92872 196.000987,45.3561919 C191.592879,56.7836639 194.707273,69.7463427 203.825671,77.9239556 C212.944069,86.1015686 226.168075,87.7915866 237.05,82.17 C234.808178,89.1518101 228.717106,94.1971375 221.44,95.1 C220.827367,95.141564 220.348999,95.6460241 220.34,96.26 L220.34,109.26 C220.339708,109.579164 220.469816,109.884594 220.70017,110.105507 C220.930524,110.32642 221.241128,110.44364 221.56,110.43 C229.465965,109.939067 236.938854,106.649294 242.64,101.15 C249.176425,95.1403206 252.927758,86.688957 253.0004,77.81 L253.0004,56.35 C253.083778,40.0288156 239.989997,26.6939622 223.67,26.479589 Z M224.83,70.07 C218.891078,70.6180232 213.245439,67.3860026 210.710995,61.9871399 C208.176552,56.5882771 209.296705,50.1801215 213.512351,45.961182 C217.727997,41.7422425 224.135276,40.6170856 229.536116,43.147312 C234.936957,45.6775384 238.173385,51.320652 237.63,57.26 C237.013399,64.0627963 231.631334,69.4574751 224.83,70.09 L224.83,70.07 Z",
    id: "Shape",
    fill: "#272424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.43,55.99 C313.43,39.6975999 300.2224,26.49 283.93,26.49 C267.6376,26.49 254.43,39.6975999 254.43,55.99 C254.43,56.27 254.43,56.54 254.43,56.82 L254.43,77.82 C254.432236,80.404322 254.123347,82.9795158 253.51,85.49 L284.7,85.49 C300.686355,85.0620284 313.424893,71.9820815 313.43,55.99 L313.43,55.99 Z M283.94,70.15 C276.119648,70.15 269.78,63.8103521 269.78,55.99 C269.78,48.1696479 276.119648,41.83 283.94,41.83 C291.760352,41.83 298.1,48.1696479 298.1,55.99 C298.094485,63.8080664 291.758066,70.1444846 283.94,70.15 L283.94,70.15 Z",
    id: "Shape",
    fill: "#272424"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F44336",
    cx: 283.94,
    cy: 55.99,
    r: 14.16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFD54F",
    cx: 223.54,
    cy: 55.99,
    r: 14.16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1DE9B6",
    cx: 163.59,
    cy: 55.99,
    r: 14.16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#40C4FF",
    cx: 118.96,
    cy: 55.99,
    r: 14.16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#282525",
    cx: 283.94,
    cy: 10.34,
    r: 10.01
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#282525",
    cx: 118.96,
    cy: 100.47,
    r: 10.01
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#282525",
    cx: 63.68,
    cy: 51.85,
    r: 10.01
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#282525",
    cx: 43.66,
    cy: 51.85,
    r: 10.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.6,40.48 C163.596929,41.2216645 164.1614,41.8425817 164.9,41.91 C170.764402,42.4460982 175.68599,46.5534019 177.262682,52.2272593 C178.839375,57.9011167 176.742498,63.9587623 171.995473,67.4436407 C167.248449,70.9285192 160.840837,71.114177 155.9,67.91 C155.68,67.77 155.47,67.62 155.27,67.47 C154.905698,67.1863904 154.427501,67.0946535 153.98411,67.2233162 C153.540718,67.3519789 153.185904,67.685438 153.03,68.12 C151.672311,71.9768156 149.674331,75.5772364 147.12,78.77 C146.856694,79.0816305 146.737934,79.4903245 146.793227,79.894535 C146.84852,80.2987455 147.072676,80.6605311 147.41,80.89 C157.865517,87.7111279 171.472367,87.2579162 181.450824,79.7561815 C191.429281,72.2544467 195.644607,59.3090697 191.996482,47.3701917 C188.348357,35.4313137 177.61724,27.053074 165.15,26.41 C164.756276,26.3797133 164.36739,26.5124433 164.074344,26.7771306 C163.781297,27.0418179 163.609806,27.4152348 163.6,27.81 L163.6,40.48 Z",
    id: "Path",
    fill: "#272424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.15,43.1 L132.57,49.04 C132.023087,49.3249049 131.787782,49.9828892 132.03,50.55 C132.749172,52.2731678 133.116377,54.1227894 133.11,55.99 C133.246811,61.136798 130.579205,65.9522808 126.143352,68.5659858 C121.707499,71.1796908 116.202501,71.1796908 111.766648,68.5659858 C107.330795,65.9522808 104.663189,61.136798 104.8,55.99 C104.794397,54.3242699 105.089109,52.6711707 105.67,51.11 C105.797023,50.7507463 105.741141,50.3521411 105.520226,50.0416662 C105.299311,49.7311913 104.941042,49.5477461 104.56,49.55 L89.71,49.55 C89.3289544,49.5463316 88.9704094,49.730044 88.7508134,50.041471 C88.5312174,50.352898 88.4785812,50.7523154 88.61,51.11 C90.1929155,55.4881344 89.5259345,60.364367 86.825458,64.1566104 C84.1249816,67.9488537 79.7350609,70.1739614 75.08,70.11 L30.3,70.11 C22.4223404,70.1161611 16.0040112,63.7869754 15.9,55.91 C15.9015773,54.0565112 16.2685757,52.2215194 16.98,50.51 C17.2290014,49.9456508 16.9970913,49.2849259 16.45,49 L4.87,43.06 C4.58563731,42.9161773 4.25519391,42.8934801 3.95383709,42.9970715 C3.65248026,43.1006629 3.40583259,43.3217352 3.27,43.61 C-0.949770259,52.7458553 -0.221321692,63.4025547 5.20236891,71.8792223 C10.6260595,80.3558899 19.9966852,85.4829994 30.06,85.4800936 L75.63,85.4800936 C83.8625872,85.5009312 91.7130685,82.0085948 97.21,75.88 C107.021583,86.5840193 123.164976,88.5528973 135.261644,80.5208489 C147.358313,72.4888005 151.807993,56.8463599 145.75,43.65 C145.614167,43.3617352 145.36752,43.1406629 145.066163,43.0370715 C144.764806,42.9334801 144.434363,42.9561773 144.15,43.1 Z",
    id: "Path",
    fill: "#272424"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAr);
export default __webpack_public_path__ + "static/media/logo_ar.a0672c59a939256dfb268010c37c8d93.svg";
export { ForwardRef as ReactComponent };